<template>
  <div class="race-question">
    <sweet-modal ref="editPromoCode" v-on:close="onClose" class="addPromoCode" title="Edit Promo Code">
      <div class="form-data-outer">
        <div class="form-data">
          <label>Promo Code</label>
          <input v-model="promoCodeData.code" >          
        </div>
         <div class="form-data">
          <label>Total Times Used </label>
          <input v-model="promoCodeData.totalTimesUsed" >         
        </div>
        <div class="form-data">
          <label>Usage Limit </label>
          <input v-model="promoCodeData.usageLimit" >         
        </div>
        <div class="form-data">
          <label>ExpirationDate</label>   

           <date-time-field v-if="show" v-model="promoCodeData.expirationDate" name="expirationDate"
             data-vv-value-path="startDate.time" data-vv-name="expirationDate" ></date-time-field>
        </div>

        <div class="form-data my-tag-field" >
          <label>Tag</label>
             <selectize v-bind:options="tagsOptions" v-model="selectedTags"
              multiple size="1" data-dropdown-parent="body" data-max-options="100"
              :isRunnerTag='false' :isRaceTag='false'
              :isPromoTag='true' :promoCodeId="promoCodeData.id" :showMe='show'
              data-value-field= 'id' data-label-field='name' data-search-field= 'name' data-sort-field= 'name'
              style="visibility:hidden">
          </selectize>
        </div>

      <div class="saveBtn">
        <button class="btn btn--primary" v-on:click="Save()" style="float:none">Save</button>
      </div>

      </div>
    </sweet-modal>
  </div>
</template>

<script>
import Vue from "vue"
import { SweetModal } from "sweet-modal-vue"
import DateTimeField from '@/components/Forms/DateTimeField'
import PromoCodeService from "../../../../services/promoCode"
import moment from 'moment'
import Selectize from '@/components/Selectize'
import TagService from '../../../../services/tag'

export default {
  name: "edit-promo-code",
  data: () => ({
   promoCodeData:{},
    tagsOptions:[],
    selectedTags:[],
  }),
  props: {
    promoData: {},
    show: false
  },
  methods: {
    onClose() {
      // this.gift = ""
      this.$emit("closed", true)
    },
    openEditModal() {
      //this.promoCodeData = this.promoData.rowData     

      var data= this.promoData.rowData 
      //var that = this
      // TagService.getAllTags().then((response)=>{
      //   that.tagsOptions = response.data    
      //   that.selectedTags = data.tags.map(a => a.id)   
      // })        
      
      if(data.expirationDate && data.expirationDate!=null){
        var stillUtc = moment.utc(data.expirationDate).toDate()
        var local = moment(stillUtc).local().format('YYYY-MM-DD HH:mm:ss')
        data.expirationDate = local
      }
      if(data.tags){
        this.selectedTags = data.tags.map(a => a.id) 
      }  
      this.promoCodeData = data
      //console.log("this.promoCodeData--",this.promoCodeData)
      this.$refs.editPromoCode.open()
    },
    Save() {
      var tagList =[]
      this.selectedTags.forEach(tag => {
        tagList.push(this.tagsOptions.find((e)=>e.id == parseInt(tag)))
      })
      if(tagList.length>0){
        this.promoCodeData.tags= tagList
      }
      //console.log("his.promoCodeData-",this.promoCodeData)

      PromoCodeService.updatePromoCode(this.promoCodeData).then(response => {
        this.$emit('saved', response.data)
        this.$refs.editPromoCode.close()
      }).catch(error => {
          console.log("err---",error) 
          this.$refs.editPromoCode.close()
      })          
    },
    getAllTags(){
      TagService.getAllTags().then((response)=>{
        //console.log("Tags----",response)
        this.tagsOptions = response.data    
      })
    },
  },
  created() {
    this.getAllTags()
   // this.$watch("show", function(val) {})
  },

  watch: {
    show(oldVal, newVal) {
      if (this.show) {
        this.openEditModal()
      }
    }
  },
  components: {
    SweetModal,
    DateTimeField,
    Selectize
  }
}
</script>
<style>
.editluckyRunner .sweet-title {
    text-align: center;
    color: #423799;
}
.editluckyRunner .sweet-modal {
  border-radius: 30px;
  border: 2px solid #ccc;
}
/* .editluckyRunner .sweet-content-content label {
    width: 100%;
    display: inline-block;margin-bottom:20px;} */
.editluckyRunner .sweet-content-content input {
    width: 85%;
    border-radius: 15px;
    border: 1px solid #ccc;
    padding: 0px 15px;
    height: 45px;
    font-size: 20px;
}
.editluckyRunner .form-data-outer {
    padding: 0px 45px 0 45px;
}
.editluckyRunner .sweet-content-content textarea {
    width: 85%;
    border-radius: 15px;
    border: 1px solid #ccc;
    padding: 12px 15px;
    min-height:90px;
}
.errorMsg {
  padding: 10px;
  color: red;
}
.editluckyRunner .sweet-modal.is-alert .sweet-content{padding:0 5px;}
.editluckyRunner .sweet-content-content label {     
    float: left;
    width: 10%;
    margin-top: 11px;
    font-size: 18px;
    margin-right: 10px;
    color: #3e3c3c;
}
.editluckyRunner .saveBtn{
  text-align: center
}
.editluckyRunner .form-data {
    margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// EditPromoCode.vue?63ed531e